import React, { PureComponent } from 'react';

import Popout from './popout';
import Avatar from './avatar';
import SelectionList from './selection-list';
import SelectionListItem from './selection-list-item';

const UserEntry = ({ user, selected, onMouseDown }) => {
    const handleMouseDown = () => {
        onMouseDown && onMouseDown(user.id);
    }

    return (
        <div className={'suggestion' + (selected ? ' selected' : '')} onMouseDown={handleMouseDown}>
            <div className="suggestion-head">
                <Avatar size="xsmall" color={user.color} secondaryColor={user.secondary_color} image={user.avatar} text={user.initials} />
            </div>

            <div className="suggestion-body">
                <div className="suggestion-body-main">
                    {
                        user.name || user.email
                    }
                </div>
            </div>
        </div>
    )
}

export default class MentionSuggestions extends PureComponent {
    static defaultProps = {
        term: null
    }

    setCtrl = ctrl => this.popoutCtrl = ctrl;

    handleSelect = index => {
        const user = this.filteredUsers[index];
        this.props.onSelect && this.props.onSelect(user.id);
    }

    handleMouseDown = userId => {
        this.props.onSelect && this.props.onSelect(userId);
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    show() {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    handleTermOrUsersUpdate() {
        if (!this.popoutCtrl) {
            return;
        }

        if (this.filteredUsers.length) {
            this.show();
            this.popoutCtrl.updatePosition();
            return;
        }

        this.hide();
    }

    get filteredUsers() {
        if (this.props.term === null) {
            return [];
        }

        const term = this.props.term.toLowerCase();
        return this.props.users.filter(user => 
            (user.email && user.email.toLowerCase().indexOf(term) > -1) ||
            (user.name && user.name.toLowerCase().indexOf(term) > -1)
        );
    }

    componentDidUpdate() {
        this.handleTermOrUsersUpdate();
    }

    render() {
        return (
            <Popout
                className="suggestions-picker-popout no-arrow"
                width="inherit"
                xAlign="left"
                defaultYPosition="top"
                provideController={this.setCtrl}
                onShow={this.props.onShow}
                onHide={this.props.onHide}
            >
                <div className="suggestions-list">
                    <SelectionList onSelect={this.handleSelect} preventEvents={true} active={true}>
                        {
                            this.filteredUsers
                                .map(user => 
                                    <SelectionListItem key={user.id}>
                                        <UserEntry
                                            user={user}
                                            onMouseDown={this.handleMouseDown}
                                        />
                                    </SelectionListItem>
                                )
                        }
                    </SelectionList>
                </div>
            </Popout>
        )
    }
}
